/**
 * Client (screen) ↔ canvas (SVG user units) conversion for the tool overlays, whose SVG spans the
 * bleed area exactly (`bleedWidth` × `bleedHeight` user units across its on-screen rect). Both
 * return `{ x: 0, y: 0 }` while the SVG is unmounted or has no layout size yet.
 */
export function toCanvasPoint(
  svg: SVGSVGElement | null,
  clientX: number,
  clientY: number,
  bleedWidth: number,
  bleedHeight: number
): { x: number; y: number } {
  if (!svg) return { x: 0, y: 0 }
  const rect = svg.getBoundingClientRect()

  if (rect.width === 0 || rect.height === 0) return { x: 0, y: 0 }
  return {
    x: (clientX - rect.left) * (bleedWidth / rect.width),
    y: (clientY - rect.top) * (bleedHeight / rect.height),
  }
}

/** Inverse of `toCanvasPoint` — doc-space point to CLIENT (screen) coordinates. Used to find
 * the shape's center in client space for the rotate pivot (same pivot convention the normal
 * selection rotate handle uses via its bounding rect's center). */
export function toClientPoint(
  svg: SVGSVGElement | null,
  docX: number,
  docY: number,
  bleedWidth: number,
  bleedHeight: number
): { x: number; y: number } {
  if (!svg) return { x: 0, y: 0 }
  const rect = svg.getBoundingClientRect()

  if (rect.width === 0 || rect.height === 0) return { x: 0, y: 0 }
  return {
    x: rect.left + docX * (rect.width / bleedWidth),
    y: rect.top + docY * (rect.height / bleedHeight),
  }
}
